module.exports = __webpack_public_path__ + "img/63.588d49ca.jpg";